export const userTypes = {
  set: 'USER/SET_USER',
  setLogged: 'USER/SET_LOGGED',
};
